import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { ForumPost, ApiForumPost } from '../../models/ForumPost';
import { useTitle } from '../../hooks/useTitle';
import { useMetaDescription } from '../../hooks/useMetaDescription';
import { useAuthUserContext } from '../../providers';
import { UserType } from '../../types';
import Header from './Header';
import Footer from '../../components/Footer';
import Spinner from '../../components/Spinner';
import DonorRecruitmentCard from './DonorRecruitmentCard';

const ForumIndex = () => {
  const [ posts, setPosts ] = useState<ForumPost[]>();
  const { get, loading } = useApi();
  const authUser = useAuthUserContext().user;
  const isDonor = authUser?.userType === UserType.Donor;

  useTitle('Ton Bébé | ドナー募集掲示板');
  useMetaDescription('Ton Bébéのドナー募集掲示板。ドニーが希望条件を投稿し、ドナーからの応募を待つことができます。現在募集中の投稿一覧をご覧いただけます。');

  useEffect(() => {
    get({
      endpoint: 'api/v1/forum_posts',
      skipAuth: true,
      onSuccess: (res) => {
        setPosts((res.data as ApiForumPost[]).map(p => new ForumPost(p)));
      },
    });
  }, [ get ]);

  return (
    <div>
      <Header />
      <main className="sub">
        <section className="archive_forum">
          <h1 className="sec_title donnie_pink">ドナー募集掲示板</h1>
          <div className="forum-donee-cta">
            <div className="forum-donee-cta-text">
              <h3>ドナー募集掲示板とは？</h3>
              <p>精子提供を希望するドニーが希望条件を投稿し、条件に合ったドナーが応募をする、新しいマッチングの仕組みです。&nbsp;<Link to="/forum_about">もっと詳しく</Link></p>
            </div>
            { !isDonor && (
              <Link to="/mypage/forum" className="pinkbtn">ドナーを募集する</Link>
            ) }
          </div>
          { loading || !posts ? (
            <Spinner centered={ true } color="pink" />
          ) : (
            <section className="forum_list_section pink">
              <h2 className="main_title"><span>{ posts.length }件募集中</span></h2>
              { posts.length === 0 ? (
                <p className="empty_message">現在募集中の投稿はありません。</p>
              ) : (
                <ul className="rec-card-list">
                  { posts.map(post => <DonorRecruitmentCard key={ post.id } post={ post } />) }
                </ul>
              ) }
            </section>
          ) }
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ForumIndex;
